import PropTypes from 'prop-types'

import Modal from '../Modal'
import SubmitButton from '../buttons/SubmitButton'

import { ReactComponent as ClapIconOutlined } from '../../../assets/images/common/icons/clap-icon-outlined.svg'
import classes from './SuccessModal.module.scss'

const SuccessModal = ({ isOpen, onClose, title, message, buttonMessage }) => (
  <Modal className={classes.modal} isOpen={isOpen} onClose={onClose}>
    <div className={classes.content}>
      <div className={classes.orangeRoundBox}>
        <ClapIconOutlined color='white' width={85} height={85} />
      </div>
      <h2 className={classes.title}>{title}</h2>
      <p className={classes.message}>{message}</p>
      <SubmitButton buttonMessage={buttonMessage} onClick={onClose} noTopMargin />
    </div>
  </Modal>
)

SuccessModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  message: PropTypes.string,
  buttonMessage: PropTypes.string,
}

export default SuccessModal
